import React, { useState } from 'react';
import "./imageViewer.scss"
import Modal from 'react-modal';
import { deleteFile } from '../../utils/apis/services/api';
import Loader from 'react-loader-spinner';
import { toast } from 'react-toastify';

const ImageViewer = props => {
    const [current, setCurrent] = useState(0)
    const [loading,setLoading] = useState(false)
    const urls = props.images?.url ?? props.images?.file ?? []
    const names = props.images?.names_of_files ?? []
    const urlList = Array.isArray(urls) ? urls : (urls ? [urls] : [])
    const nameList = Array.isArray(names) ? names : (names ? [names] : [])
    const images = urlList.map((url, i) => ({ url, name: nameList[i] || `Document ${i + 1}` })).filter((x) => x.url)

    const deleteDocument = async (fileName) => {
        setLoading(true);
        let fileDelete = await deleteFile([fileName])
        toast.dismiss()
        toast.success("Document Deleted Successfully")
        props.resetDriverDetails()
        setLoading(false)
        props.onClick()
    }
    return (

        <Modal
            isOpen={props.show}
            className="previewModal p-6"
            overlayClassName="EditOverlay"
        >
            <div className="preview">
                <span className="preview-title">Preview Documents</span>
                <i className="fa fa-close" aria-hidden="true" style={{cursor:"pointer"}}onClick={props.onClick}></i>
            </div>
          {
              loading ? <div className="ImagePreviewLoader"><Loader type="Bars" color="#03A8EE"></Loader></div>:
              images.length === 0 ? null :
              <div className="customImagepreview ml-2">
              <div className="ImagePreviewContainer">
              <div className={current === 0 ? 'nodisplay' : 'yesdisplay'}><i className="fa fa-angle-left" aria-hidden="true" onClick={() => setCurrent(current - 1)} style={{ cursor: "pointer", fontSize: 40, fontWeight: "bold" }}></i></div>
                  <div className="PreviewContainer ml-2 pl-2" >
                  <div className="trashcustomdiv"><i className="fa fa-trash trashcustom"  aria-hidden="true" onClick={() => deleteDocument(images[current].name)} ></i></div>
                  <img className="ImagePreview max-w-[calc(100%-2rem)] ml-2" alt="" src={images[current].url} aly=""></img>
                  </div>
              <div className={images.length - 1 === current ? 'nodisplay' : 'yesdisplay'}><i className="fa fa-angle-right" aria-hidden="true" onClick={() => setCurrent(current + 1)} style={{ cursor: "pointer", fontSize: 40, fontWeight: "bold"}}></i></div>
              </div>
              {/* <p style={{ fontSize: 20, whiteSpace: 'nowrap', maxWidth: 'calc(100% - 2rem)', display: 'inline-block',overflow: 'auto' }}>{images[current].name}</p> */}
          </div>
          }
        </Modal>
    );
};


export default ImageViewer;